@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../constants/spacing.module.less';

.section-wrapper {
  padding: @space-12 @space-12 @space-24;
  display: flex;
  flex-flow: column nowrap;
  gap: @space-12;

  .section {
    font-size: 12px;
    line-height: 15px;

    .title {
      color: @local-delivery--pickup--text-color;
      font-size: 14px;
      font-weight: @semi-bold;
      line-height: 18px;
    }
  }

  .contact-error-link {
    font-size: 12px;
    line-height: 15px;
  }
}
